var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 178 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7d3bec;\n      }\n\n      .cls-2 {\n        fill: #fdfcfe;\n      }\n\n      .cls-3 {\n        fill: #7e3dec;\n      }\n\n      .cls-4 {\n        fill: #fcfbfe;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.38,111.01l-131.3.02c-6.39,0-11.46-5.59-11.51-11.55l-.21-26.56c7.28-.4,12.63-5.71,12.8-12.45s-4.47-12.81-12.68-13.64l.1-28.28c.02-4.36,4.2-9.85,9.51-9.85l131.83-.08c7.34,0,12.55,5.79,12.6,12.78l.17,25.46c-7.4.59-12.73,5.88-12.92,12.66-.2,7.24,5.3,13.07,12.87,13.4l-.06,25.15c-.01,5.53-3.78,12.94-11.2,12.95ZM135.4,94.14c3.24-.66,5.69-3.29,5.7-6.14l.03-56.05c0-2.25-2.53-6.36-5.1-6.36l-91.02-.04c-3.78,0-7.09,2.42-7.09,6.5l-.03,55.93c0,3.11,3.01,6.15,6.15,6.15h91.36Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.4,94.14H44.03c-3.14,0-6.15-3.05-6.15-6.15l.03-55.93c0-4.07,3.31-6.5,7.09-6.5l91.02.04c2.57,0,5.1,4.11,5.1,6.36l-.03,56.05c0,2.85-2.46,5.47-5.7,6.14ZM132.23,34.13H46.83v51.66h85.39v-51.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.83,
    y: 34.13,
    width: 85.39,
    height: 51.66
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/Ticket.033148354aca86b2b0f7491bc5cbfed6.svg";
export { ForwardRef as ReactComponent };